import React from 'react';
import CreateEditButton from './reusables/CreateEditButton';
import { messageBusUtil, useMessageBusDispatch } from '../../../context/messagebus';
import { usePostManager } from '../../hooks/usePostManager';
const HandlePost = ({
  type,
  topic,
  reply,
  forceTypeTopic,
  forceTypeReply,
  edit,
  updateTopicPost,
  updateTopicReplies,
  navigation,
  startNewTopicButtonRef,
  slug,
  avatarUrl,
  showUserProfile,
  trackForum,
  onCloseHandler
}) => {
  // TODO: This is just a pass-thru component that does nothing, consolidate with CreateEditButton
  const isTypeTopic = forceTypeTopic || type && type === 'topic' && !forceTypeReply;
  const messageBusDispatch = useMessageBusDispatch();
  const {
    handlePost
  } = usePostManager();
  const handlePostWrapper = async data => {
    return await handlePost({
      data,
      topic,
      reply,
      slug,
      edit,
      isTypeTopic,
      messageBusUtil,
      messageBusDispatch,
      updateTopicPost,
      updateTopicReplies,
      trackForum
    });
  };
  return /*#__PURE__*/React.createElement(CreateEditButton, {
    type: type,
    isTypeTopic: isTypeTopic,
    topic: topic,
    reply: reply,
    edit: edit,
    handlePost: handlePostWrapper,
    navigation: navigation,
    startNewTopicButtonRef: startNewTopicButtonRef,
    avatarUrl: avatarUrl,
    showUserProfile: showUserProfile,
    onCloseHandler: onCloseHandler
  });
};
export default HandlePost;
//# sourceMappingURL=HandlePost.js.map